/* http通信相关常量 */
export const USER_TOKEN_HEADER_NAME = 'PY-WEB-TOKEN'
export const DEVICE_ID_HEADER_NAME = 'PY-WEB-DEVICE'
export const PLATFORM_HEADER_NAME = 'PY-WEB-PLATFORM'
export const DEVICE_MODEL_HEADER_NAME = 'PY-WEB-DEVICE-MODE'
export const APP_VERSION_HEADER_NAME = 'PY-WEB-APP-VERSION'
export const WEB_UPDATE_TIMESTAMP = 'PY-WEB-UPDATE_TIMESTAMP'



// WEBPACK FOOTER //
// ./src/constants/http_params.js